/* eslint-disable no-lonely-if */
import React from 'react';
import { FormHelperText } from '@material-ui/core';
import { preventFutureTimesMoment } from '@mummssoftware/utils/utils';
import { dateToMoment } from '@mummssoftware/utils/dates';
import { ReactDateTimePicker } from '../../DatePicker';
import { defaults } from '../en';
export const EditStartTime = ({
  startTime,
  is30MinAgency,
  onChange
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    margin: '0px 8px'
  },
  className: "edit-start-pickerDate-div"
}, /*#__PURE__*/React.createElement(FormHelperText, {
  id: "component-helper-text"
}, defaults.editStart), /*#__PURE__*/React.createElement(ReactDateTimePicker, {
  inputMargin: "0 0 4px 0",
  dateFormat: "h:mm aa",
  showTimeSelectOnly: true,
  inputWidth: "5.5rem",
  selectedDate: startTime,
  onChange: onChange,
  filterTime: time => preventFutureTimesMoment(dateToMoment(time)),
  timeIntervals: is30MinAgency ? 30 : 15
}));
export default EditStartTime;